<template>
	<div v-loading="loading">
		<div class="app-container">
			<el-descriptions title="基本信息" :column="2" border>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user"></i>
						企业名称
					</template>
					{{nbjbxx.entname}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-connection"></i>
						年报年度
					</template>
					{{nbjbxx.ancheyear}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-document-checked"></i>
						统一社会信用代码
					</template>
					{{nbjbxx.uniscid}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-date"></i>
						年报时间
					</template>
					{{ parseTime(nbjbxx.anchedate, '{y}年{m}月{d}日') }}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-phone"></i>
						联系电话
					</template>
					{{nbjbxx.tel}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-male"></i>
						年报状态
					</template>
					{{selectDictLabel(ifpubOptions,nbjbxx.ifpub)}}
				</el-descriptions-item>
				<el-descriptions-item span=2>
					<template slot="label">
						<i class="el-icon-place"></i>
						通信地址
					</template>
					{{nbjbxx.addr}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-coordinate"></i>
						经营状态
					</template>
					{{selectDictLabel(busstOptions,nbjbxx.busst)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-price-tag"></i>
						公司类型
					</template>
					{{selectDictLabel(anchetypeOptions,nbjbxx.anchetype)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-tickets"></i>
						从业人数(人)
					</template>
					{{nbjbxx.empnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-turn-off"></i>
						从业人数是否公示
					</template>
					{{selectDictLabel(isornoOptions,nbjbxx.ifpubempnum)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-school"></i>
						高校毕业生(经营人数)
					</template>
					{{nbjbxx.colgranum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-school"></i>
						高校毕业生（顾工人数）
					</template>
					{{nbjbxx.colemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user-solid"></i>
						退役士兵人数(经营人数)
					</template>
					{{nbjbxx.retsolnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-user-solid"></i>
						退役士兵人数(顾工人数)
					</template>
					{{nbjbxx.retemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-help"></i>
						残疾人(经营人数)
					</template>
					{{nbjbxx.dispernum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-help"></i>
						残疾人(顾工人数)
					</template>
					{{nbjbxx.disemplnum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-home"></i>
						失业再就业人员(经营人数)
					</template>
					{{nbjbxx.unenum}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						<i class="el-icon-s-home"></i>
						失业再就业人员(顾工人数)
					</template>
					{{nbjbxx.uneemplnum}}
				</el-descriptions-item>
			</el-descriptions>
			<div class="el-title">年报-出资信息</div>
			<el-table v-loading="loading" border :data="nbqyczxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="投资人姓名" align="center" prop="inv" />
				<el-table-column label="认缴出资额" align="center" prop="lisubconam" />
				<el-table-column label="认缴出资日期" align="center" prop="subcondate" />
				<el-table-column label="认缴出资方式" align="center" prop="subconform">
					<template slot-scope="scope">
						{{formatSubconform(scope.row.subconform)}}
					</template>
				</el-table-column>
				<el-table-column label="实缴出资额" align="center" prop="liacconam" />
				<el-table-column label="实缴出资日期" align="center" prop="accondate" />
				<el-table-column label="实缴出资方式" align="center" prop="acconform">
					<template slot-scope="scope">
						{{formatSubconform(scope.row.subconform)}}
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getNbQyCzxxList" />
			<div class="el-title">年报-股权变更信息</div>
			<el-table v-loading="loading" border :data="gqbgList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="投资人姓名" align="center" prop="inv" />
				<el-table-column label="转让前股权比例" align="center" prop="transamprpre" />
				<el-table-column label="转让后股权比例" align="center" prop="transampraf" />
				<el-table-column label="股权变更日期" align="center" prop="altdate">
					<template slot-scope="scope">
						{{ parseTime(scope.row.altdate, '{y}年{m}月{d}日') }}
					</template>
				</el-table-column>				 
			</el-table>
			<pagination v-show="totalGqbg>0" :total="totalGqbg" :page.sync="queryGqbgParams.pageNum"
				:limit.sync="queryGqbgParams.pageSize" @pagination="getNbQyGqbgxxList()" />
		    <div class="el-title">年报-对外投资信息</div>
		    <el-table v-loading="loading" border :data="dwtzList">
		    	<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
		    	<el-table-column label="对外投资企业名称" align="center" prop="entname" />
		    	<el-table-column label="对外投资企业统一社会信用代码" align="center" prop="regno" />		    	 			 
		    </el-table>
		    <pagination v-show="totalDwtz>0" :total="totalDwtz" :page.sync="queryDwtzParams.pageNum"
		    	:limit.sync="queryDwtzParams.pageSize" @pagination="getNbQyDwtzxxList()" />
			<div class="el-title">年报-对外担保信息</div>
			<el-table v-loading="loading" border :data="dwdbList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="债权人" align="center" prop="more" />
				<el-table-column label="债务人" align="center" prop="mortgagor" />
				<el-table-column label="主债权种类" align="center" prop="priclaseckind" >
					<template slot-scope="scope">
							{{scope.row.priclaseckind==='1'?'合同':'其他'}}
						</template>
				</el-table-column>	
				<el-table-column label="主债权数额(万元)" align="center" prop="priclasecam" />
				<el-table-column label="旅行债务期限" align="center" prop="pefperfrom" >
					<template slot-scope="scope">
							自{{ parseTime(scope.row.pefperfrom, '{y}-{m}-{d}') }}至{{ parseTime(scope.row.pefperto, '{y}-{m}-{d}') }}
						</template>
				</el-table-column>
				<el-table-column label="保证的期间" align="center" prop="guaranperiod" >
					<template slot-scope="scope">
							{{scope.row.guaranperiod==='1'?'期限':'未约定'}}
					</template>
				</el-table-column>
				<el-table-column label="保证的方式" align="center" prop="gatype" >
					<template slot-scope="scope">
							{{formatGatype(scope.row.gatype)}}
					</template>
				</el-table-column>
				<el-table-column label="保证担保的范围" align="center" prop="rage" />
				<el-table-column label="是否公示" align="center" prop="iftopub" >
					<template slot-scope="scope">
							{{selectDictLabel(isornoOptions,scope.row.iftopub)}}
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalDwdb>0" :total="totalDwdb" :page.sync="queryDwdbParams.pageNum"
				:limit.sync="queryDwdbParams.pageSize" @pagination="getNbQyDwdbxxList()" />
			<div class="el-title">年报-网站网店信息</div>
			<el-table v-loading="loading" border :data="wzwdList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="网站类型" align="center" prop="webtype" >
					<template slot-scope="scope">
								{{scope.row.webtype==='1'?'网站':'网店'}}
						</template>
				</el-table-column>
				<el-table-column label="网站（网店）名称" align="center" prop="websitname" />
				<el-table-column label="网站（网店）网址" align="center" prop="domain" />	
			</el-table>
			<pagination v-show="totalWzwd>0" :total="totalWzwd" :page.sync="queryWzwdParams.pageNum"
				:limit.sync="queryWzwdParams.pageSize" @pagination="getNbQyWzwdxxList()" />
			<div class="el-title">年报-党建信息</div>
			<el-table v-loading="loading" border :data="djxxList">
				<el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50" />
				<el-table-column label="党员（预备党员）人数" align="center" prop="numparm" />
				<el-table-column label="党组织建制" align="center" prop="parins" >
					<template slot-scope="scope">
								{{selectDictLabel(parinsOptions,scope.row.parins)}}
					</template>
				</el-table-column>
				<el-table-column label="经营者是否党员" align="center" prop="resparmsign" >
					<template slot-scope="scope">
									{{selectDictLabel(isornoOptions,scope.row.resparmsign)}}
						</template>
				</el-table-column>
				<el-table-column label="经营者是否党组织书记" align="center" prop="resparsecsign" >
					<template slot-scope="scope">
									{{selectDictLabel(isornoOptions,scope.row.resparsecsign)}}
						</template>
				</el-table-column>
			</el-table>
			<pagination v-show="totalDjxx>0" :total="totalDjxx" :page.sync="queryDjxxParams.pageNum"
				:limit.sync="queryDjxxParams.pageSize" @pagination="getNbQyDjxxList()" />
			<el-descriptions title="年报-社保信息" :column="2" border>
				<el-descriptions-item>
					<template slot="label">					
						城镇职工基本养老保险
					</template>
					{{sbXx.so110}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						失业保险
					</template>
					{{sbXx.so210}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						
						职工基本医疗保险
					</template>
					{{sbXx.so310}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						工伤保险
					</template>
					{{sbXx.so410}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						生育保险
					</template>
					{{sbXx.so510}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加城镇职工基本养老保险缴费基数公示情况
					</template>
					{{sbXx.totalwagesSo110}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加失业保险缴费基数公示情况
					</template>
					{{sbXx.totalwagesSo210}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加职工基本医疗保险缴费基数公示情况
					</template>
					{{sbXx.totalwagesSo310}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加工伤保险缴费基数公示情况
					</template>
					{{sbXx.totalwagesSo410}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加生育保险缴费基数公示情况
					</template>
					{{sbXx.totalwagesSo510}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位缴费基数是否公示
					</template>
					{{selectDictLabel(isornoOptions,sbXx.totalwagesdis)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						参加城镇职工基本养老保险本期实际缴费基数公示情况
					</template>
					{{sbXx.totalpaymentSo110}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						参加失业保险本期实际缴费基数公示情况
					</template>
					{{sbXx.totalpaymentSo210}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						参加职工基本医疗保险本期实际缴费基数公示情况
					</template>
					{{sbXx.totalpaymentSo310}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						参加工伤保险本期实际缴费基数公示情况
					</template>
					{{sbXx.totalpaymentSo410}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						参加生育保险本期实际缴费基数公示情况
					</template>
					{{sbXx.totalpaymentSo510}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						本期实际缴费金额是否公示
					</template>
					{{selectDictLabel(isornoOptions,sbXx.totalpaymentdis)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加城镇职工基本养老保险累计欠缴金额公示情况
					</template>
					 {{sbXx.unpaidsocialinsSo110}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加失业保险累计欠缴金额公示情况
					</template>
					 {{sbXx.unpaidsocialinsSo210}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加职工基本医疗保险累计欠缴金额公示情况
					</template>
					 {{sbXx.unpaidsocialinsSo310}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加工伤保险累计欠缴金额公示情况
					</template>
					 {{sbXx.unpaidsocialinsSo410}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位参加生育保险累计欠缴金额公示情况
					</template>
					 {{sbXx.unpaidsocialinsSo510}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">						 
						单位累计欠缴金额是否公示
					</template>
					 {{selectDictLabel(isornoOptions,sbXx.unpaidsocialinsdis)}}
				</el-descriptions-item>
			</el-descriptions>
			<el-descriptions title="年报-资产状况信息" :column="2" border>
				<el-descriptions-item>
					<template slot="label">					
						资产总额（万元）
					</template>
					{{zczkXx.assgro}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						资产总额（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifassgro)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						负债总额（万元）
					</template>
					{{zczkXx.liagro}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						负债总额（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifliagro)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						营业总收入（万元）
					</template>
					{{zczkXx.vendinc}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						营业总收入（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifvendinc)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						主营业务收入（万元）
					</template>
					{{zczkXx.maibusinc}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						主营业务收入（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifmaibusinc)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						利润总额（万元）
					</template>
					{{zczkXx.progro}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						利润总额（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifprogro)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						净利润（万元）
					</template>
					{{zczkXx.netinc}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						净利润（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifnetinc)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						纳税总额（万元）
					</template>
					{{zczkXx.ratgro}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						纳税总额（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.ifratgro)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">					
						所有者权益（万元）
					</template>
					{{zczkXx.totequ}}
				</el-descriptions-item> 				
				<el-descriptions-item>
					<template slot="label">					
						所有者权益（是否公示）
					</template>
					{{selectDictLabel(isornoOptions,zczkXx.iftotequ)}}
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
	import {
		listNbQyJbxx,
		listNbQyCzxx,
		listNbQyGqbgxx,
		listNbQyDwtzxx,
		listNbQyDwdbxx,
		listNbQyWzwdxx,
		listNbQyDjxx,
		listNbQySbxx,
		listNbQyZczkxx
	} from "@/api/qygzs/yqyd";

	export default {
		name: 'NbQyJbxx',
		props: {
			//企业内部序号
			nbjbxx: {
				type: Object,
				require: true
			}
		},
		watch: {
			nbjbxx(newValue, oldValue) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
		data() {
			return {
				// 年报企业出资信息列表
				nbqyczxxList: [],
				loading: false,
				// 选中数组
				ids: [],
				// 非单个禁用
				single: true,
				// 非多个禁用
				multiple: true,
				//【企业年报基本信息】总条数
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				//股权变更
				queryGqbgParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalGqbg: 0,
				gqbgList: [],
				//对外投资
				queryDwtzParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalDwtz: 0,
				dwtzList: [],
				//对外担保
				queryDwdbParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalDwdb: 0,
				dwdbList: [],
				//网站网店
				queryWzwdParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalWzwd: 0,
				wzwdList: [],
				//党建信息
				queryDjxxParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},
				totalDjxx: 0,
				djxxList: [],
				//社保信息
				querySbxxParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},				 
				sbXx: {},
				//资产状况信息
				queryZczkParams: {
					pageNum: 1,
					pageSize: 10,
					ancheid: undefined,
				},				 
				zczkXx: {},
				//年报状态字典
				ifpubOptions: [],
				//经营状态字典
				busstOptions: [],
				//公司类型字典
				anchetypeOptions: [],
				//是否字典
				isornoOptions: [],
				//出资方式字典
				conformOptions: [],
				//党组织建制字典
				parinsOptions: [],
			}
		},
		created() {
			this.init();
			this.getDicts("fdw_IFPUB").then(response => {
				this.ifpubOptions = response.data;
			});
			this.getDicts("fdw_BUSST").then(response => {
				this.busstOptions = response.data;
			});
			this.getDicts("fdw_ENTMIDCLASS").then(response => {
				this.anchetypeOptions = response.data;
			});
			this.getDicts("ISORNO").then(response => {
				this.isornoOptions = response.data;
			});
			this.getDicts("fdw_CONFORM").then(response => {
				this.conformOptions = response.data;
			});
			this.getDicts("fdw_PARINS").then(response => {
				this.parinsOptions = response.data;
			});
			

		},
		methods: {
			init() {
				this.loading = true;
				this.getNbQyCzxxList();
				this.getNbQyGqbgxxList();
				this.getNbQyDwtzxxList();
				this.getNbQyDwdbxxList();
				this.getNbQyWzwdxxList();
				this.getNbQyDjxxList();
				this.getNbQySbxx();
				this.getNbQyZczkxx();
			},
			//获取年报-企业出资信息列表
			getNbQyCzxxList() {
				this.loading = true;
				this.queryParams.ancheid = this.nbjbxx.ancheid;
				listNbQyCzxx(this.queryParams).then(response => {
					this.nbqyczxxList = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			//获取年报-企业股权变更信息列表
			getNbQyGqbgxxList() {
				this.loading = true;
				this.queryGqbgParams.ancheid = this.nbjbxx.ancheid;
				listNbQyGqbgxx(this.queryGqbgParams).then(response => {
					this.gqbgList = response.rows;
					this.totalGqbg = response.total;
					this.loading = false;
				});
			},
			//获取年报-对外投资信息列表
			getNbQyDwtzxxList() {
				this.loading = true;
				this.queryDwtzParams.ancheid = this.nbjbxx.ancheid;
				listNbQyDwtzxx(this.queryDwtzParams).then(response => {
					this.dwtzList = response.rows;
					this.totalDwtz = response.total;
					this.loading = false;
				});
			},
			//获取年报-对外担保信息列表
			getNbQyDwdbxxList() {
				this.loading = true;
				this.queryDwdbParams.ancheid = this.nbjbxx.ancheid;
				listNbQyDwdbxx(this.queryDwdbParams).then(response => {
					this.dwdbList = response.rows;
					this.totalDwdb = response.total;
					this.loading = false;
				});
			},
			//获取年报-对外网站网店信息列表
			getNbQyWzwdxxList() {
				this.loading = true;
				this.queryWzwdParams.ancheid = this.nbjbxx.ancheid;
				listNbQyWzwdxx(this.queryWzwdParams).then(response => {
					this.wzwdList = response.rows;
					this.totalWzwd = response.total;
					this.loading = false;
				});
			},
			//获取年报-党建信息
			getNbQyDjxxList() {
				this.loading = true;
				this.queryDjxxParams.ancheid = this.nbjbxx.ancheid;
				listNbQyDjxx(this.queryDjxxParams).then(response => {
					this.djxxList = response.rows;
					this.totalDjxx = response.total;
					this.loading = false;
				});
			},
			//获取年报-社保信息
			getNbQySbxx() {
				this.loading = true;
				this.querySbxxParams.ancheid = this.nbjbxx.ancheid;
				listNbQySbxx(this.querySbxxParams).then(response => {
					if(response.rows.length>0){
						this.sbXx=response.rows[0];
					}					 
					this.loading = false;
				});
			},
			//获取年报-资产状况信息
			getNbQyZczkxx() {
				this.loading = true;
				this.queryZczkParams.ancheid = this.nbjbxx.ancheid;
				listNbQyZczkxx(this.queryZczkParams).then(response => {
					if(response.rows.length>0){
						this.zczkXx=response.rows[0];
					}					 
					this.loading = false;
				});
			},
			/* 出资方式格式化 */
			formatSubconform(val) {
				if (this.isEmptyStr(val)) {
					return "";
				}
				const _this = this;
				let arr = val.split(",").map(function(item) {
					return _this.selectDictLabel(_this.conformOptions, item);
				});
				return arr.join("")
			},
			/* 对外担保-保证方式格式化 */
			formatGatype(val){
				if (this.isEmptyStr(val)) {
					return "";
				}
				switch(val) {
				     case "1":
				        return "一般保证"
				        break;
				     case "2":
				        return "连带保证"
				        break;
					 case "3":
					   return "未约定"
					   break;
				     default:
				        return ""
				} 
			}
		}
	}
</script>

<style scoped>
	/deep/ .el-descriptions__header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0px;
	}

	.el-title {
		box-sizing: border-box;
		font-size: 16px;
		font-weight: 700;
		color: #303133;
		padding-top: 10px;
		text-align: left;
	}
</style>
